import styled from 'styled-components';
import { ColorAddiBlack, ColorAddiGrayLighten3, ColorAddiGrayLighten4, ColorAddiPrimaryActive, ColorAddiWhite, } from '@addi/foundation/dist/web/colors';
import { FontAddiFamilySecondaryName, FontAddiWeightBold, } from '@addi/foundation/dist/web/fonts';
import { SizeAddiFontSmall, SizeAddiFontXSmall } from '@addi/foundation/dist/web/sizes';
export const Background = styled.div `
  padding: 1rem;
`;
export const TableContainer = styled.div `
  padding: 1rem;
  overflow-x: ${({ responsive }) => (responsive ? 'auto' : 'hidden')};
  background-color: ${ColorAddiWhite};
  border-radius: 8px;
  box-shadow: 0px 0px 12px rgba(86, 90, 97, 0.12);
`;
export const Table = styled.table `
  width: 100%;
  padding: 1rem;
  border-collapse: collapse;
  border-spacing: 0 1em;
  &&& ::selection {
    color: ${ColorAddiWhite};
    background: ${ColorAddiPrimaryActive};
  }
  &&& th,
  td {
    padding: ${({ compact }) => (compact ? '8px' : '12px')};
  }
`;
export const TableHeader = styled.thead `
  color: ${ColorAddiBlack};
  font-weight: ${FontAddiWeightBold};
  font-family: ${FontAddiFamilySecondaryName};
  font-size: ${SizeAddiFontSmall};
`;
export const TableBody = styled.tbody `
  background-color: #fff;
  font-family: ${FontAddiFamilySecondaryName};
  font-size: ${SizeAddiFontXSmall};
  & tr:hover {
    background-color: ${ColorAddiGrayLighten4};
  }
`;
export const TableRow = styled.tr `
  border-bottom: 1px solid ${ColorAddiGrayLighten3};
  transition: all 300ms ease-in;
`;
export const TableCellHead = styled.th `
  text-align: left;
  white-space: nowrap;
`;
export const TableCell = styled.td `
  white-space: nowrap;
`;
//# sourceMappingURL=table.styled.js.map